import React, { useState } from 'react';
import MyInvites from './MyInvites';

const ConnectionHub = () => {

  return (
    <div className="mt-2">
      <h2 className="page-main-title">Connection Hub</h2>

      <div className="greenData p-3 rounded shadow flex flex-wrap mb-4">
        <p>Earn points effortlessly by sharing your details with us, and be rewarded for the data that you choose to share.</p>
      </div>

    <div className="bg-white p-4 rounded shadow flex gap-4 flex-wrap">
       <MyInvites />        
    </div>
    </div>     
  );
};

export default ConnectionHub;
